import React from 'react'
import { jt, t } from 'ttag'

import { SelectResourceModal } from 'components/modals/common/SelectResourceModal/SelectResourceModal'

export const SelectCandidateModal = ({
  name,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const candidate = <strong key="candidate">{name}</strong>

  return (
    <SelectResourceModal
      alert={jt`You are moving ${candidate}.`}
      message={t`Are you sure you want to move?`}
      title={t`Select candidate for interview`}
      {...{ onCancel, onClose, onConfirm, isOpen }}
    />
  )
}
